import { render } from "./404.vue?vue&type=template&id=269f4538&scoped=true"
const script = {}

import "./404.vue?vue&type=style&index=0&id=269f4538&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-269f4538"]])

export default __exports__